import PostsAddEditController from './addedit/DashboardPostsAddEditController';
import PostsMainController from './main/DashboardPostsController';

export default {PostsMainController, PostsAddEditController} 


// WEBPACK FOOTER //
// ./src/app/dashboard/posts/index.ts